import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {UserProfileService} from '../services/api/user-profile.service';

export const CustomerUserGuard: CanActivateFn = (): boolean => {
  return inject(UserProfileService).getLoggedInUser()?.isCustomerUserOrPlatformAdmin();
}
